import { getCookie } from 'typescript-cookie'
import { UserClientJSON, AdminClientJSON } from '@/apiv3/index'
import { FetchRPC } from 'twirp-ts/build/twirp/http.client'

export default {
  userToken (): string {
    const token = getCookie('randomUserId')

    if (token === null || typeof token !== 'string') {
      return ''
    }

    return token
  },
  userClient (): UserClientJSON {
    const client = new UserClientJSON(FetchRPC({
      baseUrl: 'https://prepodam.ru/api',
      headers: {
        token: this.userToken()
      }
    }))

    return client
  },
  adminToken (): string {
    const token = getCookie('randomAdminId')

    if (token === null || typeof token !== 'string') {
      return ''
    }

    return token
  },
  adminClient (): AdminClientJSON {
    const client = new AdminClientJSON(FetchRPC({
      baseUrl: 'https://prepodam.ru/api',
      headers: {
        token: this.adminToken()
      }
    }))

    return client
  },
  adminNoAuthClient (): AdminClientJSON {
    const client = new AdminClientJSON(FetchRPC({
      baseUrl: 'https://prepodam.ru/api'
    }))

    return client
  }
}
